import React from 'react';
import langConf from "../js/lang";
import CallCodes from './CallCodes';
import shelegApi from '../api/shelegAPI';



class Validation extends React.Component {

    validatePhone(phone) {
        if (phone === '')
            return false;
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
        var longphoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if ((phone.match(phoneno)) || (phone.match(longphoneno))) {
            return true;
        }
        else {
            return false;
        }
    };

    handleClick = async () => {
        const lang = this.props.language;
        //console.log('this.props.callCode: ', this.props.callCode);
        let mobile = document.querySelector('#mobile').value;
        if (!this.validatePhone(mobile)) {
            alert(langConf[lang].invalidMobile);
            return false;
        }
        if (this.props.callCode === '0'){
            alert(langConf[lang].emptyCallCode);
            return false;
        }
        mobile = mobile.startsWith('0') ? mobile.slice(1, mobile.length) : mobile;
        await this.props.generateValidationCode();
        const pkg = {
            sessionId: this.props.sessionId,
            recipientNo: `+${this.props.callCode}${mobile}`,
            senderNo: '+16694000616',
            msgText: `${langConf[lang].codeWAMessage} ${this.props.validationCode}`,
        };
        //console.log('pkg: ', pkg);
        const response = await shelegApi.post('/SendWAMsg/', pkg);
        //console.log('response: ', response);
        if (response.statusText === "OK") {
            this.props.changeMobile(`+${this.props.callCode}${mobile}`);
            this.props.changeScreen('validationCode');
        }
    };

    render() {
        const lang = this.props.language;
        return (
            <div className='col-xl-12'>
                <div className="col-xl-3 col-lg-3 col-md-0 col-sm-0 col-0"></div>
                <div className='form-group col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                    <div className="col-xl-0 col-lg-0 col-md-2 col-sm-0 col-0"></div>
                    <div className='col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        <input type='tel' id='mobile' placeholder={langConf[lang].mobile} className='form-control col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7' style={{ marginTop: '5px' }} />
                        <CallCodes
                            language={this.props.language}
                            callCode={this.props.callCode}
                            callCodeName={this.props.callCodeName}
                            changeCallCode={this.props.changeCallCode}
                            changeCallCodeName={this.props.changeCallCodeName}
                        />
                    </div>
                    <div className="col-xl-0 col-lg-0 col-md-2 col-sm-0 col-0"></div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-0 col-sm-0 col-0"></div>
                <div className="col-xl-12">
                    <div className="col-xl-4 col-lg-4 col-md-2 col-sm-0 col-0"></div>
                    <div className='form-group col-xl-4 col-lg-4 col-md-8 col-sm-12 col-12'>
                        <button className='btn btn-success btn-lg btn-block' onClick={this.handleClick}><i className={`fab fa-whatsapp`}></i>{` ${langConf[lang].getValidationCode}`}</button>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-2 col-sm-0 col-0"></div>
                </div>
            </div>
        );
    }
}

export default Validation;